<template>
    <v-dialog fullscreen v-model="dialog">
        <template v-slot:activator="{ on }">
            <v-btn color="primary" block v-on="on">
                Reportar Novedad
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title
                >Reporte de Novedad</v-card-title
            >
            <v-card-text>
                <v-layout column>
                    <v-flex>
                        <v-layout column>
                            <v-flex
                                ><v-textarea
                                    outline
                                    name="what"
                                    label="¿Que pasó?"
                                    v-model="annotation.what"
                                ></v-textarea
                            ></v-flex>
                            <v-flex
                                ><v-textarea
                                    outline
                                    name="who"
                                    label="¿A quien?"
                                    v-model="annotation.who"
                                ></v-textarea
                            ></v-flex>
                            <v-flex
                                ><v-textarea
                                    outline
                                    name="how"
                                    label="¿Como?"
                                    v-model="annotation.how"
                                ></v-textarea
                            ></v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex>
                        <v-layout align-end>
                            <v-flex
                                xs4
                                v-for="(picture, index) in annotation.pictures"
                                :key="index"
                            >
                                <app-photo-frame :src="picture" :id="index" @remove="onRemove" />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-layout column>
                    <v-flex class="mb-3">
                        <app-camera v-model="annotation.pictures" :max-files="3"></app-camera>
                    </v-flex>
                    <v-divider></v-divider>
                    <v-flex class="mb-3">
                        <v-btn block :color="colorConfirm" class="white--text" @click="save"
                            >Reportar</v-btn
                        >
                    </v-flex>
                    <v-divider></v-divider>
                    <v-flex>
                        <v-btn color="error" block @click="close">Cancelar</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import PhotoFrame from '../../widgets/PhotoFrame'
import Camera from '../../widgets/Camera/Camera'
export default {
    components: {
        appPhotoFrame: PhotoFrame,
        appCamera: Camera,
    },
    data: () => ({
        dialog: false,
        annotation: {
            what: '',
            who: '',
            how: '',
            pictures: [],
        },
    }),
    watch: {
        // dialog(val) {
        //     if (!val) return
        //     if (navigator.geolocation) {
        //         navigator.geolocation.getCurrentPosition(pos => {
        //             const { latitude, longitude } = pos.coords
        //             this.annotation.latitude = latitude
        //             this.annotation.longitude = longitude
        //         })
        //     }
        // },
    },
    methods: {
        save() {
            this.$emit('save', this.annotation)
        },
        onRemove(id) {
            this.annotation.pictures.splice(id, 1)
        },
        close() {
            Object.keys(this.annotation).map(key => (this.annotation[key] = ''))
            this.annotation.pictures = []
            this.dialog = false
        },
    },
}
</script>
